// FloatingFrameWrapper.tsx

import { FloatingFrame } from "@similarweb/ai-kit";

import { StyledFloatingFrame } from "app/components/ai-kit/StyledComponents";

import { useFloatingFrameProps } from "./FloatingFrameProvider";

export const FloatingFrameWrapper = () => {
    const { frameProps, isVisible, setIsVisible, setFrameProps } = useFloatingFrameProps();
    const { config, children, showThread } = frameProps;
    return (
        <StyledFloatingFrame
            style={{
                display: isVisible ? "block" : "none",
            }}
        >
            <FloatingFrame
                showThread={showThread}
                config={config}
                eventCallback={(BaseEvent) => {
                    switch (BaseEvent.type) {
                        case "close":
                            setIsVisible(false);
                            setFrameProps((prev) => ({
                                ...prev,
                                children: null,
                            }));
                            break;
                    }
                }}
            >
                {children}
            </FloatingFrame>
        </StyledFloatingFrame>
    );
};
